import { Customer } from "./customer";
import { Product } from "./product";
import { Discount } from "./discount";
import Translations from "@/types/translations";

export enum ReceiptType {
  Pickup = "pickup",
  TakeOut = "take_out",
}

export interface Review {
  rating: number;
  message: string;
}

export interface AgeCheck {
  lineItems: ReceiptProduct[];
  requiredAge: number | null;
}

export interface CartRequestBody {
  lineItems: {
    products: {
      productId: Product["id"];
      quantity: number;
      type: "product";
    }[];
    discounts: Discount[];
  };
  qrCode: string | null;
  legalAge: number | null;
  legalAgeQr: string | null;
  ageCheck: AgeCheck;
}

export interface CalculateCartResponse {
  lineItems: {
    products: ReceiptProduct[];
    discounts: Discount[];
  };
  legalAge: number | null;
  legalAgeQr: string | null;
  ageCheck: AgeCheck;
}

export interface BaseReceiptRequestBody {
  receipt: {
    kioskLanguage: string;
    lineItems: CartRequestBody["lineItems"];
    review?: Review;
  };
}

export interface TakeOutReceiptRequestBody {
  receipt: BaseReceiptRequestBody["receipt"] & {
    type: ReceiptType.TakeOut;
  };
}

export interface PickupReceiptRequestBody {
  receipt: BaseReceiptRequestBody["receipt"] & {
    type: ReceiptType.Pickup;
    pickupStartAt: string;
    customer: Customer;
  };
}

export type ReceiptRequestBody = TakeOutReceiptRequestBody | PickupReceiptRequestBody;

interface BaseReceipt {
  id: number;
  state: "CREATED" | "STARTED" | "SUCCESS" | "FAILED";
  amountCents: number;
  vatCents: number;
  productTotalAmountCents: number;
  depositTotalAmountCents: number;
  lineItems: {
    products: CalculateCartResponse["lineItems"]["products"];
    discounts: Discount[];
  };
  review?: {
    rating: number;
    message: string;
  };
}

export interface TakeOutReceipt extends BaseReceipt {
  type: ReceiptType.TakeOut;
}

export interface PickupReceipt extends BaseReceipt {
  type: ReceiptType.Pickup;
  pickupStartAt: string;
  customer: Customer;
}

export type Receipt = TakeOutReceipt | PickupReceipt;

export interface ProductCombiDeal {
  combiDealId: number;
  combinableProductIds: Product["id"][];
  translations: Translations[];
  priceCents: number;
}

export type ReceiptProduct = {
  type: "product";
  quantity: number;
  priceCents: number;
  translations: Translations[];
  productId: Product["id"];
  combiDeals: ProductCombiDeal[];
  combiDealApplied: boolean;
};

export enum TransactionStatus {
  SUCCESS = "SUCCESS",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
}
